/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react';
import type { SVGProps } from 'react';
/**
 * @internal
 */
const SvgLock = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#909090" d="M8.733 10.405a.6.6 0 1 1-1.2 0 .6.6 0 0 1 1.2 0" />
    <path
      fill="#909090"
      fillRule="evenodd"
      d="M5.133 5v1.8h-.6c-.641 0-1.2.466-1.2 1.1v5c0 .634.559 1.1 1.2 1.1h7.2c.64 0 1.2-.466 1.2-1.1v-5c0-.634-.558-1.1-1.2-1.1h-.6V5a3 3 0 0 0-6 0m4.8 0v1.8h-3.6V5a1.8 1.8 0 1 1 3.6 0m-5.4 7.8V8h7.2v4.8z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLock;
